import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { signInUser } from 'redux/slices/user.slice';
import { persistor } from 'redux/store';
import baseApi from 'services/api/baseApi';
import { useSwitchProjectMutation } from 'services/api/user.api';
import { reloadWindow } from 'utils/windowNavigation';

interface UseSwitchProjectResult {
  switchToProject: (projectId: number | null) => Promise<void>;
  isSwitching: boolean;
}

/** Swaps the session for the Identity's User on `projectId` and reloads; rejects if the switch fails. */
export default function useSwitchProject(): UseSwitchProjectResult {
  const dispatch = useDispatch();
  const [switchProject, { isLoading: isSwitching }] = useSwitchProjectMutation();

  const switchToProject = useCallback(
    async (projectId: number | null): Promise<void> => {
      const session = await switchProject({ projectId }).unwrap();
      dispatch(baseApi.util.resetApiState());
      dispatch(signInUser(session));
      await persistor.flush();
      reloadWindow();
    },
    [dispatch, switchProject]
  );

  return { switchToProject, isSwitching };
}
